import { Box, Button, debounce, Drawer } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import React, { useCallback, useState } from "react";
import { IconOnButton } from "../button/Button";
import { InputSearchRound } from "../input/input";
import { ContainerHeaderFilter } from "./TableHeader.style";
import FilterListIcon from "@mui/icons-material/FilterList";

interface TableHeaderProps {
  addButton?: boolean;
  filterLabel?: string;
  searchBar?: boolean;
  renderRight?: React.ReactElement | React.ReactElement[];
  renderRightButton?: React.ReactElement | React.ReactElement[];
  renderFilter?: React.ReactElement | React.ReactElement[];
  renderBelowSearch?: React.ReactElement | React.ReactElement[];
  onSearch?(text: string): void;
  onClickAdd?(): void;
}

export default function TableHeader({
  addButton,
  filterLabel,
  searchBar,
  renderFilter,
  renderRight,
  renderRightButton,
  renderBelowSearch,
  onClickAdd,
  onSearch,
}: TableHeaderProps) {
  const [typeRender, setTypeRender] = useState<"Filter" | "Right">("Filter");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    type: "Filter" | "Right"
  ) => {
    setTypeRender(type);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSearch = useCallback(
    debounce((value) => {
      if (onSearch) {
        onSearch(value);
      }
    }, 500),
    []
  );

  function handleOnChange(text: string) {
    handleSearch(text);
  }

  return (
    <Box
      bgcolor={"white"}
      padding={1}
      height={"100%"}
      display={"flex"}
      borderBottom={2}
      borderColor={"#dedede"}
      borderRadius={1}
    >
      <Box flexBasis={"100%"}>
        <Box marginTop={2} marginBottom={1} display={"flex"}>
          <ContainerHeaderFilter>
            <Box>
              {searchBar && (
                <InputSearchRound
                  serachInputLabel={filterLabel || ""}
                  onFiltered={(e) => {
                    handleOnChange(e);
                  }}
                />
              )}
              {renderBelowSearch && <Box marginTop={1}>{renderBelowSearch}</Box>}
            </Box>
            <Box display={"flex"} gap={1.3}>
              {renderRightButton && (
                <Box onClick={(e: any) => handleClick(e, "Right")}>
                  {renderRightButton}
                </Box>
              )}
              {renderFilter && (
                <IconOnButton
                  icon={<FilterListIcon />}
                  text="Filter"
                  handleClick={(e: any) => handleClick(e, "Filter")}
                />
              )}
              {addButton && (
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => {
                    if (onClickAdd) {
                      onClickAdd();
                    }
                  }}
                  startIcon={<AddIcon />}
                >
                  Tambah
                </Button>
              )}
            </Box>
          </ContainerHeaderFilter>
        </Box>
      </Box>
      <Drawer anchor="right" open={open} onClose={handleClose}>
        <Box p={1} pl={2} pr={2} pb={2}>
          {typeRender === "Filter" ? renderFilter : renderRight}
        </Box>
      </Drawer>
    </Box>
  );
}
